"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9450],{

/***/ 34955:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "C1": function() { return /* binding */ scrollToProduct; },
/* harmony export */   "c9": function() { return /* binding */ getFlData; },
/* harmony export */   "n4": function() { return /* binding */ handleKeyPress; },
/* harmony export */   "nj": function() { return /* binding */ scrollToFirstProduct; },
/* harmony export */   "sR": function() { return /* binding */ getFilterQuery; },
/* harmony export */   "ur": function() { return /* binding */ getSortList; }
/* harmony export */ });
/* unused harmony export scrollToVisualNav */
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47956);

const getSortList = (staticTexts)=>[
        {
            name: staticTexts.featured
        },
        {
            name: staticTexts.bestSellers,
            query: "bestSeller_l+asc"
        },
        {
            name: staticTexts.priceDesc,
            query: "price+desc"
        },
        {
            name: staticTexts.priceAsc,
            query: "price+asc"
        },
        {
            name: staticTexts.atoz,
            query: "productName_s+asc"
        },
        {
            name: staticTexts.ztoa,
            query: "productName_s+desc"
        }
    ];
const handleKeyPress = (e, width, filterRef, cb)=>{
    if (width < 992) {
        const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
        const focusContent = filterRef.current.querySelectorAll(focusElements);
        const firstElem = focusContent[0];
        const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
        if (e.key === "Escape") {
            cb(false);
        }
        if (e.key === "Tab") {
            if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterRef.current)) {
                e.preventDefault();
                lastElem.focus();
            }
            if (!e.shiftKey && document.activeElement === lastElem) {
                e.preventDefault();
                firstElem.focus();
            }
        }
    }
};
const scrollToProduct = ()=>{
    const urlParams = window.location.search;
    let queryVal = "";
    let isBackSkuExists = false;
    if (urlParams) {
        const urlQuery = urlParams.replace("?", "").split("&");
        urlQuery.forEach((query, i)=>{
            const isBack = query.split("=")[0] === "back";
            if (isBack) {
                sessionStorage.plpScrollSku = query.split("=")[1];
                isBackSkuExists = true;
            }
            queryVal += isBack ? "" : "".concat(i > 0 ? "&" : "").concat(query);
        });
        window.history.replaceState(window.location.pathname, document.title, queryVal.length > 0 ? "?".concat(queryVal.toString()) : window.location.pathname);
        if (sessionStorage.plpScrollSku) {
            const scrollPosition = document.getElementById(sessionStorage.plpScrollSku);
            let IterCount = 10;
            const scorllObjInterval = setInterval(()=>{
                if (scrollPosition) {
                    scrollPosition.scrollIntoView({
                        behavior: "smooth",
                        block: "start",
                        inline: "nearest"
                    });
                    if (IterCount === 0) {
                        delete sessionStorage.plpScrollSku;
                        clearInterval(scorllObjInterval);
                    }
                    IterCount--;
                }
            }, 150);
        } else if (!isBackSkuExists) {
            scrollToFirstProduct(false, true);
        }
    } else {
        scrollToTop();
    }
};
const scrollToFirstProduct = function() {
    let isFaq = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, shouldScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    setTimeout(()=>{
        const scrollPositions = isFaq ? document.querySelectorAll("div.product-listing") : document.querySelectorAll(".product-listing");
        if (scrollPositions && scrollPositions.length > 0 && shouldScroll) {
            window.scrollTo({
                top: scrollPositions[0].offsetTop,
                behavior: "smooth"
            });
        } else {
            scrollToTop();
        }
    }, 200);
};
const scrollToVisualNav = ()=>{
    const timeoutId = setTimeout(()=>{
        const scrollPositions = document.querySelectorAll("div.filter-conatiner");
        if (scrollPositions && scrollPositions.length > 0) {
            window.scrollTo({
                top: scrollPositions[0].offsetTop,
                behavior: "smooth"
            });
        } else {
            scrollToTop();
        }
    }, 200);
    return ()=>{
        clearTimeout(timeoutId);
    };
};
const scrollToTop = ()=>{
    window.scrollTo(0, 0);
};
const getFlData = (persona)=>[
        "id",
        "sku_s",
        "slug_s",
        "metaTitle_s",
        "productName_s",
        "masterSKU_s",
        "Product_Category",
        "ProductLocalCategory_s",
        "ProductBrandName_s",
        "productImages.url_ss",
        "displayPriceStartingAt_s",
        "SKUColorSwatchFilename_ss",
        "ProductDescriptionProductShort_s",
        "priceList.".concat(persona, ".price_d"),
        "priceList.".concat(persona, ".finalPrice_d"),
        "priceList.".concat(persona, ".discountedPrice_d"),
        "priceList.".concat(persona, ".saleOffer_s"),
        "priceStartingAt.".concat(persona, "_d"),
        "discountedPriceStartingAt.".concat(persona, "_d"),
        "variantList.sku_ss",
        "Color.SKU.Details_ss",
        "Color.".concat(persona, ".Details_ss"),
        "ProductIsExclusive_s",
        "RegionReleaseforShipment_dt",
        "productImages.labelWithUrl_ss",
        "RegionOnBackOrder_s",
        "RegionBrandName_s",
        "ProductIsRetail",
        "comboSKUAvailable_b",
        "category1_s",
        "ProductBrandNameDisplay_s",
        "ctId_s",
        "ProductProductNo_s",
        "ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss",
        "ProductResource.PartsPDFFileName.resourceFullWebURL_ss",
        _constants_index__WEBPACK_IMPORTED_MODULE_0__.resourceFacetLabels.join(","),
        "SKUInventoryStatus_s",
        "SKUAnnSacksNonStock_b",
        "noBadge_b",
        "Sale.".concat(persona, ".Details_ss"),
        "RegionAltUOM_s",
        "ItemCharacteristic.TYPE.CharacteristicDescription_s",
        "ItemCharacteristic.TYPE.CharacteristicTypeDescriptionKey_s",
        "ItemCharacteristic.TYPE.CharacteristicDescriptionUpperCase_s"
    ];
const getFilterQuery = function(type, query) {
    let queries = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], persona = arguments.length > 3 ? arguments[3] : void 0;
    const fq = type === "parts" ? [] : [
        query
    ];
    queries.forEach((q)=>{
        const tag = '{!tag="'.concat(q.facet, '"}');
        if (!q.facet.match(/^\*{2}/)) {
            q.facet === "Price_Range" ? fq.push(encodeURIComponent('{!tag="priceList.'.concat(persona, '.finalPrice_d"}priceList.').concat(persona, ".finalPrice_d:(").concat(q.value.join(" OR "), ")").replaceAll("+", " "))) : fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")').replaceAll("+", " ")));
            return;
        }
        q.facet === "Price_Range" ? fq.push("priceList.".concat(persona, ".finalPrice_d:(").concat(encodeURIComponent(q.value), ")").replaceAll("+", " ")) : fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")').replaceAll("+", " "));
    });
    return fq;
};



/***/ }),

/***/ 75455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(47956);
/* harmony import */ var _components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(82476);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination_analytics_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77906);





const LoadMore = (param)=>{
    let { totalResults =0 , staticTexts ={} , onLoadMore =()=>{} , curRows =30 , data =[] , page ="" , removeLoadAnimation =false  } = param;
    const [buttonVisible, setButtonVisible] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const transformClassName = removeLoadAnimation ? "no-transform" : "";
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (totalResults > _constants_index__WEBPACK_IMPORTED_MODULE_2__.DEFAULT_PRODUCT_COUNT_PLP && totalResults > curRows && totalResults > (data === null || data === void 0 ? void 0 : data.length)) {
            setButtonVisible(true);
        } else {
            buttonVisible && setButtonVisible(false);
        }
    }, [
        totalResults,
        _constants_index__WEBPACK_IMPORTED_MODULE_2__.DEFAULT_PRODUCT_COUNT_PLP,
        curRows,
        data === null || data === void 0 ? void 0 : data.length
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "product-listing__row gbh-data-layer",
        "data-gbh-data-layer": (0,_components_ProductList_v2_ProductListView_Pagination_analytics_js__WEBPACK_IMPORTED_MODULE_4__/* .getLoadMoreAnalyticsData */ .Ql)(page),
        children: buttonVisible && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Button_Button__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            type: "load-more",
            size: "small",
            customClass: "product-listing__load-more ".concat(transformClassName),
            label: staticTexts.loadMore,
            onClick: onLoadMore,
            parentClass: "div-wrapper",
            role: "button"
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (LoadMore);


/***/ }),

/***/ 47537:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85518);
/* harmony import */ var _public_icons_back_top_arrow_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(12522);
/* harmony import */ var _public_icons_print_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(30402);
/* harmony import */ var _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(66773);
/* harmony import */ var _components_ProductList_v2_ProductListView_ProductsPerPage__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(93575);
/* harmony import */ var _components_cart_OrderSummary_SocialShare__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(738);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(77906);
/* harmony import */ var _utils__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(20558);










const Pagination = (param)=>{
    let { displayPrint ="" , staticTexts ={} , displayShare ="" , curRows =30 , productsPerPage =[] , totalResults =0 , onRows =()=>{} , handleBackToTop =()=>{} , width =1280 , isSearchTab =false , page ="" , type ="" , customClass ={} , includeWrapper =true  } = param;
    const { print ="" , share ="" , backToTop =""  } = staticTexts;
    const [showSocialLink, setShowSocialLink] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { buttonClass ="" , spanClass ="" , imgClass =""  } = customClass !== null && customClass !== void 0 ? customClass : {};
    const getBackToTopAnalyticsData = ()=>{
        if (isSearchTab && page === "search") return (0,_components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .searchGetBackToTopAnalytics */ .tf)(type);
        else if (page === "technicalspecs") return _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .technicalSpecGetBackToTopAnalytics */ .gr;
        else if (page === "plp") return _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .plpGetBackToTopAnalytics */ .a$;
        else if (page === "press-release") return _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .pressReleaseGetBackToTopAnalytics */ .FH;
        else if (page === "press-kit") return _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .pressKitGetBackToTopAnalytics */ .tm;
        else return _components_ProductList_v2_ProductListView_Pagination_analytics__WEBPACK_IMPORTED_MODULE_8__/* .defaultGetBackToTopAnalytics */ .cI;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_utils__WEBPACK_IMPORTED_MODULE_9__/* .ConditionalWrapper */ .M2, {
        condition: includeWrapper,
        wrapper: (children)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "product-listing__row",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "product-listing__back-to-top",
                    children: children
                })
            }),
        children: [
            react_device_detect__WEBPACK_IMPORTED_MODULE_2__/* .isMobile */ .tq && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "product-listing__print-and-share",
                children: [
                    displayPrint === "true" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        role: "button",
                        onClick: ()=>{
                            return window === null || window === void 0 ? void 0 : window.print();
                        },
                        children: [
                            print,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _public_icons_print_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === null || _public_icons_print_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_print_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"].src */ .Z.src,
                                alt: print
                            })
                        ]
                    }),
                    displayShare === "true" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("span", {
                        role: "button",
                        onClick: ()=>setShowSocialLink(!showSocialLink),
                        children: [
                            share,
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === null || _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_share_svg__WEBPACK_IMPORTED_MODULE_5__/* ["default"].src */ .Z.src,
                                alt: share
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_cart_OrderSummary_SocialShare__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        showModal: showSocialLink,
                        id: "kf-product-listing",
                        onClose: ()=>setShowSocialLink(false)
                    })
                ]
            }),
            width > 1023 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductListView_ProductsPerPage__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                pos: "bottom",
                curRows: curRows,
                data: productsPerPage,
                totalResults: totalResults,
                texts: staticTexts,
                onChange: onRows,
                selectedTab: type,
                page: page
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                role: "link",
                className: "".concat(buttonClass || "product-listing__go-back", " gbh-data-layer"),
                "data-gbh-data-layer": getBackToTopAnalyticsData(),
                onClick: handleBackToTop,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: "".concat(spanClass || "product-listing__go-back-text"),
                        children: backToTop
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        className: "".concat(imgClass || "product-listing__go-back-image"),
                        "aria-hidden": "true",
                        src: _public_icons_back_top_arrow_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === null || _public_icons_back_top_arrow_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z === void 0 ? void 0 : _public_icons_back_top_arrow_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"].src */ .Z.src,
                        alt: backToTop
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Pagination);


/***/ }),

/***/ 77906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "FH": function() { return /* binding */ pressReleaseGetBackToTopAnalytics; },
/* harmony export */   "Ql": function() { return /* binding */ getLoadMoreAnalyticsData; },
/* harmony export */   "a$": function() { return /* binding */ plpGetBackToTopAnalytics; },
/* harmony export */   "cI": function() { return /* binding */ defaultGetBackToTopAnalytics; },
/* harmony export */   "gr": function() { return /* binding */ technicalSpecGetBackToTopAnalytics; },
/* harmony export */   "tf": function() { return /* binding */ searchGetBackToTopAnalytics; },
/* harmony export */   "tm": function() { return /* binding */ pressKitGetBackToTopAnalytics; }
/* harmony export */ });
/* unused harmony exports searchLoadMoreAnalyticsData, technicalSpecLoadMoreAnalyticsData, articleLoadMoreAnalyticsData, defaultLoadMoreAnalyticsData */
const searchGetBackToTopAnalytics = (type)=>JSON.stringify({
        eventAction: "search results:".concat(type, ":main content area:back to top"),
        eventName: "search results:".concat(type, ":main content area:back to top"),
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "back to top",
        internalLinkPosition: "search results",
        internalLinkType: "search results:navigation",
        internalLinkZoneName: "search results:".concat(type, ":main content area"),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    });
const technicalSpecGetBackToTopAnalytics = JSON.stringify({
    eventAction: "technical specs:main content area:back to top",
    eventName: "technical specs:main content area:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "tech specs",
    internalLinkType: "technical specs:navigation",
    internalLinkZoneName: "technical specs:main content area",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const plpGetBackToTopAnalytics = JSON.stringify({
    eventAction: "plp:back to top",
    eventName: "plp:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "plp",
    internalLinkType: "plp:navigation",
    internalLinkZoneName: "plp:promo tiles",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const pressReleaseGetBackToTopAnalytics = JSON.stringify({
    eventAction: "press room:press releases:back to top",
    eventName: "press room:press releases:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "press room",
    internalLinkType: "press room:navigation",
    internalLinkZoneName: "press room:press releases:main content area",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const pressKitGetBackToTopAnalytics = JSON.stringify({
    eventAction: "press room:press kits:back to top",
    eventName: "press room:press kits:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "press room",
    internalLinkType: "press room:navigation",
    internalLinkZoneName: "press room:press kits:main content area",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const defaultGetBackToTopAnalytics = JSON.stringify({
    eventAction: "support:help and faq:article list:back to top",
    eventName: "support:help and faq:article list:back to top",
    eventType: "navigation",
    eventMsg: "n/a",
    eventStatus: "n/a",
    internalLinkName: "back to top",
    internalLinkPosition: "support:help and faq",
    internalLinkType: "support:help and faq:navigation",
    internalLinkZoneName: "support:help and faq:article list",
    internalLinkURL: "n/a",
    clickInternalLinks: "true"
});
const searchLoadMoreAnalyticsData = '{"eventAction":"search results:products:main content area:load more","eventName":"search results:products:main content area:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"search results","internalLinkType":"search results:load more","internalLinkZoneName":"search results:products:main content area","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const technicalSpecLoadMoreAnalyticsData = '{"eventAction":"technical specs:main content area:load more","eventName":"technical specs:main content area:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"tech specs","internalLinkType":"technical specs:load more","internalLinkZoneName":"technical specs:main content area","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const articleLoadMoreAnalyticsData = '{"eventAction":"support:help and faq:article list:load more","eventName":"support:help and faq:article list:load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"support:help and faq","internalLinkType":"support:help and faq:load more","internalLinkZoneName":"support:help and faq:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const defaultLoadMoreAnalyticsData = '{"eventAction":"plp load more","eventName":"plp load more","eventType":"navigation","eventMsg":"n/a","eventStatus":"n/a","internalLinkName":"load more","internalLinkPosition":"plp","internalLinkType":"plp:load more","internalLinkZoneName":"plp:promo tiles","internalLinkURL":"n/a","clickInternalLinks":"true"}';
const getLoadMoreAnalyticsData = function() {
    let page = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    let analyticsData = "";
    if (page === "search") {
        analyticsData = searchLoadMoreAnalyticsData;
    } else if (page === "technicalspecs") {
        analyticsData = technicalSpecLoadMoreAnalyticsData;
    } else if (page === "article") {
        analyticsData = articleLoadMoreAnalyticsData;
    } else {
        analyticsData = defaultLoadMoreAnalyticsData;
    }
    return analyticsData;
};


/***/ }),

/***/ 73812:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v2_Sort; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-device-detect/dist/lib.js
var lib = __webpack_require__(85518);
// EXTERNAL MODULE: ./public/icons/arrow-up.svg
var arrow_up = __webpack_require__(97274);
;// CONCATENATED MODULE: ./src/components/ProductList/v2/Sort/sortAnalytics.js
const getAnalyticsData = function(item) {
    let needJson = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, { selectedtab , page  } = arguments.length > 2 ? arguments[2] : void 0;
    let analyticsData = {
        eventType: "navigation",
        eventMsg: "n/a",
        eventStatus: "n/a",
        internalLinkName: "".concat(item.name),
        internalLinkURL: "n/a",
        clickInternalLinks: "true"
    };
    if (page === "search" && selectedtab === "technical") {
        analyticsData = {
            ...analyticsData,
            eventAction: "search results:technical:main content area:sort by",
            eventName: "search results:technical:main content area:sort by",
            internalLinkPosition: "search results",
            internalLinkType: "search results:sort by",
            internalLinkZoneName: "search results:technical:main content area"
        };
    }
    switch(page){
        case "search":
            analyticsData = {
                ...analyticsData,
                eventAction: "search results:".concat(selectedtab, ":main content area:sort by"),
                eventName: "search results:".concat(selectedtab, ":main content area:sort by"),
                internalLinkPosition: "search results",
                internalLinkType: "search results:sort by",
                internalLinkZoneName: "search results:".concat(selectedtab, ":main content area")
            };
            break;
        case "favorites":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:favorites:".concat(selectedtab, ":sort by"),
                eventName: "my account:favorites:".concat(selectedtab, ":sort by"),
                internalLinkPosition: "favorites",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:favorites:".concat(selectedtab)
            };
            break;
        case "article":
            analyticsData = {
                ...analyticsData,
                eventAction: "support:help and faq:article list​:sort by",
                eventName: "support:help and faq:article list​:sort by",
                internalLinkPosition: "knowledge articles",
                internalLinkType: "support:help and faq:sort by",
                internalLinkZoneName: "support:help and faq:article list​​"
            };
            break;
        case "active-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:active services​:sort by",
                eventName: "my account:services:active services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:active services"
            };
            break;
        case "past-services":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:services:past services​:sort by",
                eventName: "my account:services:past services​:sort by",
                internalLinkPosition: "my services",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:services:past services"
            };
            break;
        case "literature":
            analyticsData = {
                ...analyticsData,
                eventAction: "literature:sort by",
                eventName: "literature:sort by",
                internalLinkPosition: "literature",
                internalLinkType: "literature:sort by",
                internalLinkZoneName: "literature:main content area"
            };
            break;
        case "press-release":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press releases:sort by",
                eventName: "press room:press releases:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press releases:main content area"
            };
            break;
        case "press-kits":
            analyticsData = {
                ...analyticsData,
                eventAction: "press room:press kits:sort by",
                eventName: "press room:press kits:sort by",
                internalLinkPosition: "press room",
                internalLinkType: "press room:sort by",
                internalLinkZoneName: "press room:press kits:main content area"
            };
            break;
        case "my products":
            analyticsData = {
                ...analyticsData,
                eventAction: "my account:products:sort by filter",
                eventName: "my account:products:sort by filter",
                internalLinkPosition: "my account",
                internalLinkType: "my account:sort by",
                internalLinkZoneName: "my account:products"
            };
            break;
        default:
            analyticsData = {
                ...analyticsData,
                eventAction: "plp sort by filter",
                eventName: "plp sort by filter",
                internalLinkPosition: "plp",
                internalLinkType: "plp:sort by",
                internalLinkZoneName: "plp:sort by filter"
            };
    }
    if (needJson) return analyticsData;
    return JSON.stringify(analyticsData);
};

// EXTERNAL MODULE: ./src/hooks/useIsSsr.js
var useIsSsr = __webpack_require__(7154);
;// CONCATENATED MODULE: ./src/hooks/useOnClickOutside.js


/**
 *
 * @param {*} ref
 * @param {*} handler
 */ const useOnClickOutside = (ref, handler)=>{
    const isSsr = (0,useIsSsr/* default */.Z)();
    (0,react.useEffect)(()=>{
        const listener = (event)=>{
            // Do nothing if clicking ref's element or descendent elements
            if (!ref.current || ref.current.contains(event.target)) {
                return;
            }
            handler(event);
        };
        if (!isSsr) {
            document.addEventListener("mousedown", listener);
            document.addEventListener("touchstart", listener);
        }
        return ()=>{
            document.removeEventListener("mousedown", listener);
            document.removeEventListener("touchstart", listener);
        };
    }, // Add ref and handler to effect dependencies
    // It's worth noting that because passed in handler is a new ...
    // ... function on every render that will cause this effect ...
    // ... callback/cleanup to run every render. It's not a big deal ...
    // ... but to optimize you can wrap handler in useCallback before ...
    // ... passing it into this hook.
    [
        ref,
        handler,
        isSsr
    ]);
};
/* harmony default export */ var hooks_useOnClickOutside = (useOnClickOutside);

;// CONCATENATED MODULE: ./src/components/ProductList/v2/Sort/index.jsx






function Sort(param) {
    let { texts ={} , data =[] , selectedSort , onChange , page , selectedtab , tabIndex =0 , isMyFavoriteTab =false  } = param;
    const id = (0,react.useId)();
    const [isOpen, setIsOpen] = (0,react.useState)(false);
    const [activeIndex, setActiveIndex] = (0,react.useState)(0);
    const wrapper = (0,react.useRef)(null);
    const trigger = (0,react.useRef)(null);
    const options = (0,react.useRef)([]);
    const label = texts.sort || texts.sortByAria || "Sort by";
    hooks_useOnClickOutside(wrapper, ()=>setIsOpen(false));
    (0,react.useEffect)(()=>{
        var ref;
        if (isOpen) (ref = options.current[activeIndex]) === null || ref === void 0 ? void 0 : ref.focus();
    }, [
        isOpen,
        activeIndex
    ]);
    const open = ()=>{
        if (!data.length) return;
        setActiveIndex(Math.max(0, data.findIndex((item)=>{
            return item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name);
        })));
        setIsOpen(true);
    };
    const close = ()=>{
        var ref;
        setIsOpen(false);
        (ref = trigger.current) === null || ref === void 0 ? void 0 : ref.focus();
    };
    const select = (item)=>{
        onChange(item);
        close();
    };
    const onOptionKeyDown = (event, index)=>{
        switch(event.key){
            case "ArrowDown":
                event.preventDefault();
                setActiveIndex((index + 1) % data.length);
                break;
            case "ArrowUp":
                event.preventDefault();
                setActiveIndex((index - 1 + data.length) % data.length);
                break;
            case "Home":
            case "End":
                event.preventDefault();
                setActiveIndex(event.key === "Home" ? 0 : data.length - 1);
                break;
            case "Enter":
            case " ":
                event.preventDefault();
                select(data[index]);
                break;
            case "Escape":
                event.preventDefault();
                event.stopPropagation();
                close();
                break;
            case "Tab":
                // Return to the trigger before the browser performs normal Tab navigation.
                close();
                break;
            default:
                break;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "sort".concat(isOpen ? " sort--open" : ""),
        ref: wrapper,
        onBlur: (event)=>{
            if (!event.currentTarget.contains(event.relatedTarget)) setIsOpen(false);
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                type: "button",
                tabIndex: tabIndex,
                className: "sort__toggle",
                ref: trigger,
                id: "".concat(id, "-label"),
                "aria-haspopup": "listbox",
                "aria-expanded": isOpen,
                "aria-controls": "".concat(id, "-options"),
                onClick: ()=>isOpen ? close() : open(),
                onKeyDown: (event)=>{
                    if ([
                        "ArrowDown",
                        "ArrowUp"
                    ].includes(event.key)) {
                        event.preventDefault();
                        open();
                    } else if (event.key === "Escape" && isOpen) {
                        event.preventDefault();
                        close();
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sort-by-text",
                        children: label
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "sort-options",
                        children: " ".concat(isMyFavoriteTab ? "" : ":", " ").concat((selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name) || "Featured")
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                        src: arrow_up/* default */.Z === null || arrow_up/* default */.Z === void 0 ? void 0 : arrow_up/* default.src */.Z.src,
                        alt: "",
                        className: "sort__toggle-icon"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("ul", {
                id: "".concat(id, "-options"),
                className: "sort__drop-down",
                role: "listbox",
                "aria-labelledby": "".concat(id, "-label"),
                hidden: !isOpen,
                style: !isOpen ? {
                    display: "none"
                } : undefined,
                children: data.map((item, index)=>{
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)("li", {
                        id: "".concat(id, "-option-").concat(index),
                        role: "option",
                        ref: (element)=>{
                            options.current[index] = element;
                        },
                        tabIndex: isOpen && activeIndex === index ? 0 : -1,
                        "aria-selected": item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name),
                        className: "sort__item gbh-data-layer".concat(item.name === (selectedSort === null || selectedSort === void 0 ? void 0 : selectedSort.name) ? " active" : ""),
                        "data-gbh-data-layer": getAnalyticsData(item, null, {
                            selectedtab,
                            page
                        }),
                        onFocus: ()=>setActiveIndex(index),
                        onClick: ()=>select(item),
                        onKeyDown: (event)=>onOptionKeyDown(event, index),
                        children: item.name
                    }, index);
                })
            })
        ]
    });
}
/* harmony default export */ var v2_Sort = ((0,lib/* withOrientationChange */.Qe)(Sort));


/***/ })

}]);